export const IFRAME_ID = "builder-ui-preview-iframe";
export const IFRAME_DATA_TEST_ID = "builder-ui-frame";
